<template>
	<a-modal v-model="is_revocation" title="确认转交吗?" width="50%">
		<template slot="footer">
			<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
			<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 转交 </a-button>
		</template>
		<a-form :form="form2" :labelCol="labelCol" :wrapperCol="wrapperCol">
			<a-row>
				<a-col :span="8">
					<a-form-item label="转交公司">
						<a-select allowClear placeholder="转交公司" @change="handlecompanyplan" v-decorator="['companyId', { rules: [{ required: true, message: '请选择隶属公司!' }] }]">
							<a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
								{{ item.title }}
							</a-select-option>
						</a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="转交部门">
						<a-select allowClear v-decorator="['applyDeptId', { rules: [{ required: true, message: '请选择隶属部门!' }] }]"
						 :disabled="!form2.getFieldValue('companyId')" placeholder="转交部门" @change="leaderid($event)">
							<a-select-option :value="item.value" v-for="(item, index) in deptlist" :key="index">
								{{ item.title }}
							</a-select-option>
						</a-select>
					</a-form-item>
				</a-col>
				<a-col :span="8">
					<a-form-item label="转交人">
						<a-select showSearch optionFilterProp="children" allowClear class="margin_self" v-decorator="['applyUser', { rules: [{ required: true, message: '请选择申请人!' }] }]"
						 :disabled="!form2.getFieldValue('applyDeptId')" placeholder="转交人">
							<a-select-option :value="item.userId" v-for="(item, index) in plainOptions" :key="index">
								{{ item.userName }}
							</a-select-option>
						</a-select>
					</a-form-item>
				</a-col>
			</a-row>
		</a-form>
		<a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入原因" v-model="comment" />
	</a-modal>
</template>

<script>
import { tree_all } from '@/api/purchase'
	import {
		task_reassignment
	} from '@/api/activiti'
	import debounce from 'lodash/debounce'
	import {
		get_users2
	} from '@/utils/unit_axios'
	export default {
		data() {
			return {
				comment: '',
				record: '',
				form2: this.$form.createForm(this),
				companylist: [],
				deptlist: [],
				plainOptions: [],
				is_revocation: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 8
					}
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					}
				},
			}
		},
		created() {
			tree_all().then(res=>{
				this.companylist = res.data[0]
				this.companylist.unshift({
						value: 0,
						title: '所有公司',
						children: [],
					})
			})
		},
		methods: {
			show(record) {
				this.comment = ''
				this.form2.setFieldsValue({
					companyId: undefined,
					applyDeptId: undefined,
					applyUser: undefined,
				})
				this.is_revocation = true
				this.record = record.record
				console.log(this.record)
			},
			leaderid(id) {
				this.form2.setFieldsValue({
					applyUser: undefined
				})
				console.log(id,'id++++++++++++++++++++++')
				get_users2(id, (res) => {
					this.plainOptions = res
					console.log(this.plainOptions,'this.plainOptions++++++++++++++++++++++')
				})
			},
			handlecompanyplan(value) {
				this.deptlist = []
				this.form2.setFieldsValue({
					applyDeptId: undefined,
					applyUser: undefined
				})
				this.$nextTick(() => {
					this.companylist.forEach((item) => {
						if (item.value == this.form2.getFieldValue('companyId')) {
							this.deptlist = item.children
							console.log(this.deptlist,'this.deptlist+++++++++++++++++++++++++++++++++++')
						}
					})
				})
			},
			handleOkReason: debounce(
				function() {
					this.form2.validateFields((err, values) => {
						if (!err) {
							 this.$store.commit('LOADING', true)
                             this.$store.commit('TIPS', '转交中......')
							task_reassignment({
								taskId: this.record.id,
								userId: this.$store.getters.userInfo.userId,
								newUserId: values.applyUser,
								businessKey: this.record.businessKey,
								taskDefKey: this.record.taskDefKey,
								reason: this.comment
							}).then(res => {
								this.$store.commit('LOADING', false)
                                this.$store.commit('TIPS', '加载中......')
								if (res.code != 200) {
									this.$message.error(res.msg)
									return
								}
								this.$message.success('转交成功')
								this.$emit('sure')
								this.is_revocation = false
							})
						}
					})
				},
				1000, {
					leading: true,
					trailing: false,
				}
			),
		}
	}
</script>

<style>
</style>
